
export const FETCH_DECISION_LOOKUP_REQUEST = 'FETCH_DECISION_LOOKUP_REQUEST';
export const FETCH_DECISION_LOOKUP_REQUEST_COMPLETED = 'FETCH_DECISION_LOOKUP_REQUEST_COMPLETED';
export const FETCH_DECISION_LOOKUP_REQUEST_ERROR = 'FETCH_DECISION_LOOKUP_REQUEST_ERROR';

export const FETCH_DECISION_REQUEST = 'FETCH_DECISION_REQUEST';
export const FETCH_DECISION_REQUEST_COMPLETED = 'FETCH_DECISION_REQUEST_COMPLETED';
export const FETCH_DECISION_REQUEST_ERROR = 'FETCH_DECISION_REQUEST_ERROR';
export const FETCH_DECISION_RESET = 'FETCH_DECISION_RESET';

export const FETCH_DECISION_LIST_REQUEST = 'FETCH_DECISION_LIST_REQUEST';
export const FETCH_DECISION_LIST_REQUEST_COMPLETED = 'FETCH_DECISION_LIST_REQUEST_COMPLETED';
export const FETCH_DECISION_LIST_REQUEST_ERROR = 'FETCH_DECISION_LIST_REQUEST_ERROR';
export const FETCH_DECISION_LIST_RESET = 'FETCH_DECISION_LIST_RESET';

export const FETCH_DECISION_USER_LIST_REQUEST = 'FETCH_DECISION_USER_LIST_REQUEST';
export const FETCH_DECISION_USER_LIST_REQUEST_COMPLETED = 'FETCH_DECISION_USER_LIST_REQUEST_COMPLETED';
export const FETCH_DECISION_USER_LIST_REQUEST_ERROR = 'FETCH_DECISION_USER_LIST_REQUEST_ERROR';

export const ADD_DECISION_INITIAL = 'ADD_DECISION_INITIAL';
export const ADD_DECISION_REQUEST = 'ADD_DECISION_REQUEST';
export const ADD_DECISION_REQUEST_COMPLETED = 'ADD_DECISION_REQUEST_COMPLETED';
export const ADD_DECISION_REQUEST_ERROR = 'ADD_DECISION_REQUEST_ERROR';


// WEBPACK FOOTER //
// ./constants/decisiondetails.js